import { useState } from "react";
import { borderTabsSubTitle } from "../../../../Data/UiKitsData/TabsData";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { BorderTabsTitle } from "../../../../Utils/Constants";
import BorderTabContent from "./BorderTabContent";
import BorderNav from "./BorderNav";

export default function BorderTabs( {employeeIdProp}: {employeeIdProp:number}) {
    const [basicTab, setBasicTab] = useState<string>('1');
    
    return (
        <Col xxl={12}>
            <Card>
                {/* <CommonCardHeader headClass="card-no-border pb-0" title={BorderTabsTitle} subTitle={borderTabsSubTitle} /> */}
                <CardBody>
                    <BorderNav basicTab={basicTab} setBasicTab={setBasicTab} />
                    <BorderTabContent tabId={basicTab} employeeIdProp={employeeIdProp} />
                </CardBody>
            </Card>
        </Col>
    )
}
